import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { ElMessage } from 'element-plus'
import { getUrlParams } from '@/assets/js/utils'
import myStore from '../../store/index'
import { filterHost } from '@/utils/filterHost.js'
import { filterLoginPath } from '@/utils/filterLoginPath.js'
// 初始化axios实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 30000,
  headers: {},
})
instance.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'
instance.defaults.headers.post['Content-Type'] = 'application/json'
instance.defaults.headers.put['Content-Type'] = 'application/json'

const filterIsNeedChannelUserToken = (config, channelToken) => {
  if (!channelToken) return false
  if (config.url.includes('common_api')) return false
  return true
}
// 过滤url前缀链接
const filterConfigUrl = (config) => {
  // 前缀
  const prefix = '/cloud-credit-api'
  const prefix2 = '/cloud-credit2-api/external-channel/basic'
  const prefix3 = '/mini-program2/external-channel/basic'
  // 定制的域名，还是走最原始的逻辑
  // if (!filterHost()) {
  //   return (config.prefix || prefix) + config.url
  // }
  // 渠道账户一体化的
  if (config.prefix == '/mini-program2') {
    return prefix3 + config.url
  }
  // 渠道账户一体化的
  if (config.url.includes('channel_admin')) {
    return (config.prefix || prefix2) + config.url
  }
  // 最原始的兜底
  return (config.prefix || prefix) + config.url
}
// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // console.log('config', config)
    // if (config.url.includes('/external-channel')) {
    //   config.baseURL = process.env.VUE_APP_ZQPX_API
    // }
    // if (getUrlParams('partner_code') != localStorage.getItem('wp_partner_code')) {
    //   if (!filterHost()) {
    //     router.push({ path: '/login' })
    //   } else {
    //     window.location.href = filterLoginPath()
    //   }
    // }
    if (!config.postErrorLog) {
      config.url = filterConfigUrl(config)
    }
    // config.url = 'http://192.168.16.112:8010' + (config.prefix || prefix) + config.url
    // 设置站点信息
    const partnerCode = getUrlParams('partner_code') || localStorage.getItem('wp_partner_code')
    // const partnerCode = getUrlParams('partner_code')
    if (partnerCode) {
      config.headers['partner-code'] = partnerCode
    }
    // 管理后台token
    const channelToken = localStorage.getItem('wp_ct-channel-token')
    // 统一身份登录接口所需的token
    const loginToken = localStorage.getItem('we_ct-unifyuser-token')
    // 存贮token，这个token的作用是，不需要登录单独打开千企千面报告页，的临时token
    const ct_channel_api_token = localStorage.getItem('wfzx_channel_ct_channel_api_token')
    if (partnerCode && channelToken && !filterHost()) {
      config.headers['ct-channel-token'] = channelToken
    }
    // 渠道账户一体化的token
    const channelUserToken = localStorage.getItem('integration_channel_user_token')
    if (filterIsNeedChannelUserToken(config, channelUserToken)) {
      config.headers['channel-user-token'] = channelUserToken
    }
    if (loginToken) {
      // 配置统一身份登录接口所需的token
      config.headers['ct-unifyuser-token'] = loginToken
    }
    // 告诉后端，当前页面是 起业云 单独打开的页面，还是标准版登陆渠道后台的页面
    // 使用 URLSearchParams 构造函数解析URL
    const urlSearchParams = new URLSearchParams(window.location.href)
    const urlSearchResult = urlSearchParams.get('ct-channel-token-source') || localStorage.getItem('ct-channel-token-source')
    if (urlSearchResult) {
      config.headers['ct-channel-token-source'] = urlSearchResult
    }
    // 配置 起业云 统一身份登录接口所需的token，用于单独打开千企千面报告页的定制需求
    if (ct_channel_api_token && filterIsNeedChannelUserToken(config, ct_channel_api_token) && !filterHost() && urlSearchResult) {
      // config.headers['ct-channel-api-token'] = ct_channel_api_token
      config.headers['channel-user-token'] = ct_channel_api_token
    }
    // console.log('interceptors.request', config);
    return config
  },
  (error) => {
    console.log('interceptors.request', [error])
    return Promise.reject(error)
  },
)

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    if (response.data.code == '0000102') {
      if (!filterHost()) {
        store.commit('setUserInfo', '')
        router.push({ path: '/login' })
      } else {
        window.location.href = filterLoginPath()
      }
      return response.data
    }
    // 将后端的返回内容解套
    return response.data
  },
  (error) => {
    console.log('interceptors.response', [error])
    if (!error.response) {
      ElMessage.error(error.message)
    }
    return Promise.reject(error)
  },
)

// get请求
const get = (url, params, prefix) => {
  return instance({
    url: url,
    method: 'GET',
    params,
    prefix,
  })
}

// post请求
const post = (url, data, prefix, other) => {
  return instance(
    {
      url: url,
      method: 'POST',
      data,
      prefix,
    },
    other,
  )
}

// 发送错误请求日志的接口
const postErrorLog = (url, data) => {
  return instance({
    url: url,
    method: 'POST',
    data,
    postErrorLog: true,
  })
}

// put请求
const put = (url, data, prefix) => {
  return instance({
    url: url,
    method: 'PUT',
    data,
    prefix,
  })
}

// delete请求
const deleteApi = (url, data, prefix) => {
  return instance({
    url: url,
    method: 'DELETE',
    data,
    prefix,
  })
}

export { instance, get, post, postErrorLog, put, deleteApi }
